import React, { Suspense, useEffect } from "react";

import { App as AntApp, ConfigProvider } from "antd";

import { AdminGeneralContextProvider, AdminUserContextProvider, NavContextProvider } from "utils";

import { Layout, MetaData } from "components";

import { AdminNav } from "pages/admin/_app/components/AdminNav";
import { AdminRoutes } from "pages/admin/_app/routes";

export const Admin = () => {
  const addTinyMce = () => {
    const script = document.createElement("script");
    script.src = "/tinymce/tinymce.min.js";
    script.referrerpolicy = "origin";
    document.body.appendChild(script);
  };

  useEffect(() => {
    addTinyMce();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const { Content } = Layout;

  return (
    <>
      <MetaData title="Klim Admin" />
      <ConfigProvider theme={{ hashed: false }}>
        <AntApp>
          <AdminUserContextProvider>
            <AdminGeneralContextProvider>
              <NavContextProvider>
                <Layout>
                  <AdminNav />
                  <Layout>
                    <Content className="with-navbar admin">
                      <Suspense fallback={<></>}>
                        <AdminRoutes />
                      </Suspense>
                    </Content>
                  </Layout>
                </Layout>
              </NavContextProvider>
            </AdminGeneralContextProvider>
          </AdminUserContextProvider>
        </AntApp>
      </ConfigProvider>
    </>
  );
};
